export default function PageNotFound() {


    return (
        <>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4 pagenotfound">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                </div>
                <h1>403</h1>
                <h3>Access Denied</h3>
                <p>The page your are trying to access has restricted access.<br/>Please refer to system administrator. </p>
            </main>
        </>
    );
}
